import styled from "styled-components";
import PrimaryButton from "../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../components/FormControls/SecondaryButton";
import FormSelectWithLabel from "../../../../components/FormControls/FormSelectWithLabel";
import { useState } from "react";
import request from "../../../../api/request";
import NotificationManager from "react-notifications/lib/NotificationManager";

const FadeBackground = styled.div`
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10000;
    left: 0;
    top: 0;
    background-color: #32323233;
`;

const StyledCopyYear = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    box-sizing: border-box;
    width: 400px;
    height: 310px;
    border-radius: 5px;
    margin: auto;
    padding: 30px;
    font-size: 12px;
    font-weight: 600;
    z-index: 9999;
`;

const ModalTitle = styled.span`
    color: ${(props) => props.theme.color.dark};
    font-weight: 600;
    font-size: 20px;
`;

function CopyYear(props) {

    let currentYear = new Date().getFullYear();
    const [fromYear, setFromYear] = useState(currentYear);
    const [toYear, setToYear] = useState(currentYear);
    const [isSaving, setIsSaving] = useState(false);

    let years = [];
    for (let i = currentYear - 30; i < currentYear + 20; i ++) {
        years.push(i);
    }

    const handleClickFadeBackground = (e) => {
        if (props.handleClickNo) {
            props.handleClickNo();
        }
        e.stopPropagation();
        e.preventDefault();
    }

    const onClickCopyYear = async () => {
        setIsSaving(true);
        let saveData = {fromYear: fromYear, toYear: toYear};
        const resp = (await request('database', 'copyYear', [saveData]));
        if (resp.ok) {
            NotificationManager.success('Successfully copied year');
        } else {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsSaving(false);
    }

    return (
        <FadeBackground onClick={handleClickFadeBackground}>
            <StyledCopyYear onClick={(e) => {e.stopPropagation(); e.preventDefault()}} {...props}>
                <ModalTitle>Copy year</ModalTitle>
                <FormSelectWithLabel label='From accounting year' items={years} value={fromYear.toString()} onChange={(e) => setFromYear(parseInt(e.target.value))} style={{width:340, height:35, paddingLeft:10}} selectStyle={{marginTop:15}}></FormSelectWithLabel>
                <FormSelectWithLabel label='To accounting year' items={years} value={toYear.toString()} onChange={(e) => setToYear(parseInt(e.target.value))} style={{width:340, height:35, paddingLeft:10}}></FormSelectWithLabel>
                <div style={{display:'flex', marginTop:30}}>
                    <SecondaryButton caption='Cancel' onClick={() => props.handleClickNo ? props.handleClickNo() : {}} style={{width:120, height:35}}></SecondaryButton>
                    <PrimaryButton caption='Copy year' isLoading={isSaving} onClick={() => onClickCopyYear()} style={{width:120, height:35, marginLeft:'auto'}}></PrimaryButton>
                </div>
            </StyledCopyYear>
        </FadeBackground>
    );
}

export default CopyYear;